(function (window, document) {
    if (document.querySelector('.article-slider') !== null) {

        /**
         * Add slick slider
         */
        function addSlickSlider() {
            $('.article-slider .newslist-listing').slick({
                infinite: false,
                slidesToShow: 4,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });

            var cardGroup = $('.article-slider .newslist-listing .card-group');
            Array.prototype.forEach.call(cardGroup, function (el) {
                el.classList.remove('col-md-4');
            });
        }
        addSlickSlider();
    }
})(window, document);
